import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="text-center !py-4 text-primary !bg-[#fff] text-sm">
      © {new Date().getFullYear()} Innovate Labs. All rights reserved.
    </footer>
  );
};

export default Footer;
